import script from "./AdminListSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminListSection.vue?vue&type=script&setup=true&lang=ts"

import "./AdminListSection.vue?vue&type=style&index=0&id=61398818&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61398818"]])

export default __exports__